import React, { useState } from "react";

import { Spacer } from "components/base/Spacer";
import Modal from "components/Modal";
import PaymentDetails from "../../PaymentDetails";


export default ({
    accountId,
    show,
    curKey,
    onClose
}) => {

    const [allowGetList, setAllowGetList] = useState(false);

    return (
        <Modal
            {...{ show, onClose }}
            title="Payment details"
            width={"90%"}
            overflow={false}
            onEntered={() => {
                setAllowGetList(true);
            }}
            onClose={() => {
                onClose(false);
                setAllowGetList(false);
            }}
        >
            <PaymentDetails allowGetList={allowGetList} accountId={accountId} curKey={curKey} />
            <Spacer />
        </Modal>
    );
};